import React from "react";
import {BrowserRouter as Router, Route, Routes } from "react-router-dom";


import "@fortawesome/fontawesome-free/css/all.min.css";
import './assets/styles/tailwind.css';
import './assets/styles/App.css';
import "@fontsource/montserrat";

import AuthProvider from "./components/Authentication/AuthProvider.js";
import ProtectedRoute from './AppRoute.js';

import HealthCheck from "./views/HealthCheck.js";
import Index from "./views/Index.js";
import Login from "./views/Login.js";
import Logout from "./views/Logout.js";
import FunderMandates from "./views/FunderMandates.js";
import User from "./views/User.js";
import TermsAndConditions from "./views/TermsAndConditions.js";
import Error404 from "./views/Error404.js";

import PlatformDashboard from "./views/PlatformDashboard.js";
import InvestorDashboard from "./views/InvestorDashboard.js";
import Segmentation from "./views/Segmentation.js";
import PredictionDashboard from "./views/PredictionDashboard.js";
import PredictionOpportunity from "./views/PredictionOpportunity.js";

import Admin from "./views/Admin.js";
import AdminFileLog from "./views/AdminFileLog.js";
import AdminActivityLog from "./views/AdminActivityLog.js";
import AdminUserList from "./views/AdminUsers.js";
import AdminUserPermissions from "./views/AdminUserPermissions.js";
import AdminFunder from "./views/AdminFunders.js";
import AdminFunderCapital from "./views/AdminFunderCapital.js";
import AdminFunderCapitalCreate from "./views/AdminFunderCapitalCreate.js"
import AdminOpportunityMap from "./views/AdminOpportunityMap.js";
import AdminApiKey from "./views/AdminApiKey.js";
import {Auth0Provider} from "@auth0/auth0-react";

const domain = window.__RUNTIME_CONFIG__.REACT_APP_AUTH0_DOMAIN;
const clientId = window.__RUNTIME_CONFIG__.REACT_APP_AUTH0_CLIENT_ID;
const aud = window.__RUNTIME_CONFIG__.REACT_APP_AUTH0_AUD;

function App() {
    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/login/callback`,
                audience: aud,
                scope: 'openid profile email',
            }}
            cacheLocation="localstorage"
        >
            <Router>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Index/>}/>
                        <Route path="/login/*" exact={false} element={<Login/>}/>
                        <Route path="/logout" element={<Logout/>}/>
                        <Route path="/user" element={<User/>}/>
                        <Route path="/health_check" element={<HealthCheck/>}/>
                        <Route path="/terms-of-use" element={<TermsAndConditions/>}/>

                        <Route path="/platform" element={<PlatformDashboard/>}/>
                        <Route path="/investment" element={<InvestorDashboard/>}/>
                        <Route path="/segmentation" element={<Segmentation/>}/>
                        <Route path="/funder" element={<FunderMandates/>}/>
                        <Route path="/opportunity" element={<PredictionDashboard/>}/>
                        <Route path="/opportunities" element={<PredictionOpportunity/>}/>

                        {/* These should be for superusers */}
                        <Route path="/admin" element={<ProtectedRoute allowedRoles={['is_superuser']}><Admin /></ProtectedRoute>}/>
                        <Route path="/importlog" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminFileLog /></ProtectedRoute>}/>
                        <Route path="/activitylog" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminActivityLog /></ProtectedRoute>}/>
                        <Route path="/userlist" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminUserList /></ProtectedRoute>}/>
                        <Route path="/userpermission" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminUserPermissions /></ProtectedRoute>}/>
                        <Route path="/funderlist" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminFunder /></ProtectedRoute>}/>
                        <Route path="/opportunitylist" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminOpportunityMap /></ProtectedRoute>}/>
                        <Route path="/fundercapital" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminFunderCapital /></ProtectedRoute>}/>
                        <Route path="/capitalmanagement" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminFunderCapitalCreate /></ProtectedRoute>}/>
                        <Route path="/apikeys" element={<ProtectedRoute allowedRoles={['is_superuser']}><AdminApiKey /></ProtectedRoute>}/>
                        <Route path="*" element={<Error404/>}/>
                        <Route path="/unauthorized" element={<Error404/>}/>
                    </Routes>
                </AuthProvider>
            </Router>
        </Auth0Provider>
    );
}

export default App;
